import { Store } from './store';

export class Product
{
    ProductID;
    ProductName;
    UserID;
    CategoryID;
    SubCategoryID;
    SizeID;
    SizeValue;
    PackageID;
    MeasurementID;
    ApplicationID;
    BrandID;
    UPC;
    Signature;
    CheeseCutID;
    VarietyID;
    ContentID;
    applicationNumber;
    StoreProducts: Store[];
    ImageProducts: any[];
    
    constructor(){
        this.StoreProducts = new Array<Store>();
    }
}